import { Outlet } from "react-router-dom";
import Footer from "../footer";
import Header from "../header";
import { Box } from "@mui/material";
import vecotrs from "../../assets/images/vectors.png";
const Layout = () => {
  return (
    <Box
      sx={{
        background: "#13082A",
        backgroundImage: vecotrs,
      }}
    >
      <Box>
        <Header />
        <Box
          sx={{
            minHeight: "80.25vh",
          }}
        >
          <Outlet />
        </Box>
        <Footer />
        {/* <LoginError open={!isAuthenticated} /> */}
      </Box>
    </Box>
  );
};
export default Layout;
